(function () {
  'use strict';

  if (window.__FannCartV2Loaded) return;
  window.__FannCartV2Loaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var NOTE_START = '[FANN BLISS PERSONALIZATION]';
  var NOTE_END = '[/FANN BLISS PERSONALIZATION]';
  var state = { busy: false };

  function requestJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok) throw new Error(body.description || body.message || 'We could not update your cart.');
        return body;
      });
    });
  }

  function cartGet() {
    return requestJson(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  }

  function visibleItems(cart) {
    return (cart.items || []).filter(function (item) {
      return !(item.properties && item.properties['_FB Service Item'] === 'true');
    });
  }

  function visibleCount(cart) {
    return visibleItems(cart).reduce(function (sum, item) { return sum + item.quantity; }, 0);
  }

  function customerNote(note) {
    note = note || '';
    var start = note.indexOf(NOTE_START);
    var end = note.indexOf(NOTE_END);
    if (start !== -1 && end > start) return (note.slice(0, start) + note.slice(end + NOTE_END.length)).trim();
    return note.trim();
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-AE', { style: 'currency', currency: 'AED', maximumFractionDigits: 2 })
        .format(cents / 100).replace('AED', 'AED ');
    } catch (error) {
      return 'AED ' + (cents / 100).toFixed(cents % 100 ? 2 : 0);
    }
  }

  /* Shopify can split one bottle line into several (each with its own discount); they keep the same _FB Group ID and
     share one design service line, so quantities are counted per group, not per line */
  function groupQuantities(items) {
    var totals = {};
    items.forEach(function (item) {
      var group = item.properties && item.properties['_FB Group ID'];
      if (group) totals[group] = (totals[group] || 0) + item.quantity;
    });
    return totals;
  }

  function generatedNote(cart) {
    var lines = [];
    var services = (cart.items || []).filter(function (item) {
      return item.properties && item.properties['_FB Service Item'] === 'true';
    });
    var visible = visibleItems(cart);
    var groupQty = groupQuantities(visible);
    var noted = {};
    var number = 0;

    visible.forEach(function (item) {
      var properties = item.properties || {};
      if (!properties['Personalization Option']) return;
      var group = properties['_FB Group ID'];
      if (group && noted[group]) return;
      if (group) noted[group] = true;
      number += 1;
      lines.push('ITEM ' + number + ': ' + item.product_title + ' × ' + (group ? groupQty[group] : item.quantity));
      var service = services.find(function (candidate) {
        return candidate.properties && candidate.properties['_FB Parent Group'] === group;
      });
      Object.keys(properties).forEach(function (key) {
        if (key.charAt(0) === '_' || !properties[key]) return;
        lines.push(key + ': ' + String(properties[key]));
      });
      if (service) {
        lines.push('Custom Design Service: AED 15 × ' + service.quantity + ' = ' + money(service.final_line_price));
      }
      lines.push('---');
    });

    if (!lines.length) return '';
    return NOTE_START + '\n' + lines.join('\n') + '\n' + NOTE_END;
  }

  function updateOrderNote(cart, explicitCustomerNote) {
    var personal = typeof explicitCustomerNote === 'string' ? explicitCustomerNote.trim() : customerNote(cart.note);
    var generated = generatedNote(cart);
    var next = [personal, generated].filter(Boolean).join('\n\n');
    if ((cart.note || '').trim() === next.trim()) return Promise.resolve(cart);
    return requestJson(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: next })
    });
  }

  function updateCounts(cart) {
    var count = visibleCount(cart);
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      if (node.textContent.trim() !== String(count)) node.textContent = count;
    });
    document.querySelectorAll('[data-cart-text]').forEach(function (node) {
      var label = count === 1 ? 'item' : 'items';
      if (node.textContent.trim() !== label) node.textContent = label;
    });
    document.querySelectorAll('[data-fb-visible-count]').forEach(function (node) { node.dataset.fbVisibleCount = count; });
    return count;
  }

  /* the drawer's subtotal breakdown: open by default only on screens at least 750px wide and 940px tall, and once the shopper opens or closes it that
     choice is kept when the drawer re-renders */
  var sumPref = null;
  function syncSummary() {
    document.querySelectorAll('[data-fb-sum]').forEach(function (box) {
      if (box.__fbSum) return;
      box.__fbSum = true;
      var wide = window.matchMedia && window.matchMedia('(min-width: 750px) and (min-height: 940px)').matches;
      box.open = sumPref === null ? !!wide : sumPref;
      box.addEventListener('toggle', function () { if (box.__fbUser) sumPref = box.open; });
      var summary = box.querySelector('summary');
      if (summary) summary.addEventListener('click', function () { box.__fbUser = true; });
    });
  }

  function watchNativeCartRefreshes() {
    var sidebar = document.querySelector('#halo-cart-sidebar');
    if (!sidebar || sidebar.dataset.fbCountObserver === 'true') return;
    var timer;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      syncSummary();
      timer = window.setTimeout(function () {
        cartGet().then(updateCounts).catch(function () {});
      }, 120);
    });
    observer.observe(sidebar, { childList: true, subtree: true, characterData: true });
    sidebar.dataset.fbCountObserver = 'true';
  }

  function refreshSideCart(cart, open) {
    return fetch(ROOT + 'cart?view=ajax_side_cart', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('We could not refresh your cart.');
        return response.text();
      })
      .then(function (html) {
        var wrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
        if (wrapper) wrapper.innerHTML = html;
        syncSummary();
        updateCounts(cart);
        if (open) document.body.classList.add('cart-sidebar-show');
        document.dispatchEvent(new CustomEvent('fann:cart-refreshed', { detail: cart }));
        return cart;
      });
  }

  function updateLines(updates) {
    return requestJson(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  function addMissingService(item, quantity) {
    var properties = item.properties || {};
    var variantId = Number(properties['_FB Service Variant ID']);
    if (!variantId || !properties['_FB Group ID']) return Promise.resolve();
    return requestJson(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity || item.quantity,
        properties: {
          '_FB Service Item': 'true',
          '_FB Parent Group': properties['_FB Group ID'],
          'Design Service': 'AED 15 per bottle',
          'Service For': item.product_title
        }
      })
    });
  }

  function reconcileCart(cart) {
    var bottles = visibleItems(cart);
    var serviceItems = (cart.items || []).filter(function (item) {
      return item.properties && item.properties['_FB Service Item'] === 'true';
    });
    var groups = {};
    var updates = {};
    var missing = [];
    var groupQty = groupQuantities(bottles);
    var checked = {};

    bottles.forEach(function (item) {
      var properties = item.properties || {};
      var group = properties['_FB Group ID'];
      if (group) groups[group] = item;
      if (properties['Personalization Option'] === 'Design It for Me' && group && !checked[group]) {
        checked[group] = true;
        var service = serviceItems.find(function (candidate) {
          return candidate.properties && candidate.properties['_FB Parent Group'] === group;
        });
        if (service && service.quantity !== groupQty[group]) updates[service.key] = groupQty[group];
        if (!service) missing.push({ item: item, quantity: groupQty[group] });
      }
    });

    serviceItems.forEach(function (service) {
      var parent = service.properties && service.properties['_FB Parent Group'];
      if (!parent || !groups[parent]) updates[service.key] = 0;
    });

    var sequence = Promise.resolve(cart);
    if (Object.keys(updates).length) sequence = sequence.then(function () { return updateLines(updates); });
    missing.forEach(function (entry) {
      sequence = sequence.then(function () { return addMissingService(entry.item, entry.quantity); });
    });
    return sequence.then(cartGet);
  }

  function setBusy(busy) {
    state.busy = busy;
    document.querySelectorAll('[data-fb-cart-root], [data-fb-cart-page]').forEach(function (node) {
      node.classList.toggle('is-updating', busy);
      node.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
  }

  function showError(message) {
    var root = document.querySelector('[data-fb-cart-root], [data-fb-cart-page]');
    if (!root) return;
    var box = root.querySelector('[data-fb-cart-error]');
    if (!box) {
      box = document.createElement('div');
      box.dataset.fbCartError = '';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:10px 16px;padding:10px;border:1px solid #f2a4b8;border-radius:10px;background:#fff3f6;color:#a51d42;font-size:11px;font-weight:700;';
      root.prepend(box);
    }
    box.textContent = message;
  }

  function afterCartChange(cart, source) {
    return updateOrderNote(cart).then(function (updatedCart) {
      updateCounts(updatedCart);
      if (source && source.closest('[data-fb-cart-page]')) {
        window.location.reload();
        return updatedCart;
      }
      return refreshSideCart(updatedCart, true);
    });
  }

  function changeCard(card, quantity) {
    if (state.busy) return;
    var itemKey = card.dataset.itemKey;
    var serviceKey = card.dataset.linkedServiceKey;
    var updates = {};
    var next = Math.max(0, quantity);
    updates[itemKey] = next;
    if (serviceKey) {
      /* the service covers the whole group (a split bottle line has several cards): keep it equal to the group total */
      var groupQty = parseInt(card.dataset.fbGroupQty, 10);
      var lineQty = parseInt(card.dataset.fbQty, 10);
      updates[serviceKey] = groupQty > 0 && lineQty >= 0 ? Math.max(0, groupQty - lineQty + next) : next;
    }
    setBusy(true);
    updateLines(updates)
      .then(function (cart) { return afterCartChange(cart, card); })
      .catch(function (error) { showError(error.message); })
      .finally(function () { setBusy(false); });
  }

  function checkout(button) {
    if (state.busy) return;
    var scope = button.closest('[data-fb-cart-root], [data-fb-cart-page]') || document;
    var terms = scope.querySelector('.fb-cart-terms input');
    if (terms && !terms.checked) {
      terms.focus();
      showError('Please accept the terms before checkout.');
      return;
    }
    setBusy(true);
    cartGet()
      .then(reconcileCart)
      .then(function (cart) {
        var noteInput = document.querySelector('[data-fb-customer-note]');
        return updateOrderNote(cart, noteInput ? noteInput.value : undefined);
      })
      .then(function () { window.location.href = ROOT + 'checkout'; })
      .catch(function (error) {
        showError(error.message);
        setBusy(false);
      });
  }

  document.addEventListener('click', function (event) {
    var plus = event.target.closest('[data-fb-plus]');
    var minus = event.target.closest('[data-fb-minus]');
    var remove = event.target.closest('[data-fb-remove]');
    var checkoutButton = event.target.closest('[data-fb-checkout]');
    var saveNote = event.target.closest('[data-fb-save-note]');

    if (plus || minus) {
      event.preventDefault();
      var card = (plus || minus).closest('[data-fb-cart-item]');
      var input = card && card.querySelector('[data-fb-quantity] input');
      if (!card || !input) return;
      var quantity = Math.max(1, parseInt(input.value, 10) || 1) + (plus ? 1 : -1);
      if (quantity < 1) quantity = 1;
      changeCard(card, quantity);
      return;
    }

    if (remove) {
      event.preventDefault();
      var removeCard = remove.closest('[data-fb-cart-item]');
      if (removeCard) changeCard(removeCard, 0);
      return;
    }

    if (checkoutButton) {
      event.preventDefault();
      checkout(checkoutButton);
      return;
    }

    if (saveNote) {
      event.preventDefault();
      if (state.busy) return;
      var note = document.querySelector('[data-fb-customer-note]');
      var status = document.querySelector('[data-fb-note-status]');
      setBusy(true);
      cartGet().then(function (cart) { return updateOrderNote(cart, note ? note.value : ''); })
        .then(function () { if (status) status.textContent = 'Order note saved'; })
        .catch(function (error) { showError(error.message); })
        .finally(function () { setBusy(false); });
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-fb-quantity] input')) return;
    var card = event.target.closest('[data-fb-cart-item]');
    var quantity = Math.max(1, parseInt(event.target.value, 10) || 1);
    if (card) changeCard(card, quantity);
  });

  window.FannCartV2 = {
    updateOrderNote: updateOrderNote,
    refreshSideCart: refreshSideCart,
    reconcileCart: reconcileCart,
    updateCounts: updateCounts,
    visibleCount: visibleCount
  };

  function syncInitialCount() {
    syncSummary();
    watchNativeCartRefreshes();
    cartGet().then(updateCounts).catch(function () {});
  }

  document.addEventListener('shopify:section:load', watchNativeCartRefreshes);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncSummary); else syncSummary();

  if ('requestIdleCallback' in window) window.requestIdleCallback(syncInitialCount, { timeout: 1800 });
  else window.setTimeout(syncInitialCount, 800);
})();
